<template>
  <div class="zujianview1" v-if="dialogVisible">
    <!-- <div class="header">
      <span @click="closeDialog"><i class="el-icon-back"></i> 返回</span>
      <strong class="zujiantitle">{{ title }}</strong>
    </div> -->
    <div class="zujiancontent1">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "PopupFrame",
  props: {
    dialogVisible: {
      type: Boolean,
      required: true,
      default: false,
    },
    title: {
      type: String,
      required: false,
      default: "",
    },
  },
  methods: {
    // 关闭弹窗
    closeDialog() {
      this.$emit("update:dialogVisible", false);
    },
  },
};
</script>

<style>
.zujianview1 {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #f5f6f6;
  color: #333;
  z-index: 11;
  min-height: 100vh;
  overflow-y: auto;
}
.header {
  height: 40px;
  border-bottom: #6972a1 1px solid;
  line-height: 40px;
  text-align: center;
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
}
.header span {
  cursor: pointer;
  /* position: absolute; */
  /* left: 50px; */
}
.zujiancontent1 {
  /* padding: 30px; */
  /* margin-top: 41px; */
  min-height: 75vh;
  overflow-y: auto;
}
.zujiantitle {
  display: inline-block;
  margin: 0 auto;
}
</style>
